import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import React, { useState, useEffect } from 'react'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ReviewApiHandler from 'lib/api/review'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import { segmentPdpGoToOrdersClicked } from 'components/pdp/reviews/pdp-reviews-segment/pdpReviewsSegment'
import StateStorage from 'lib/state-storage'
import styles from './product-reviews-empty.scss'

const ProductReviewsEmpty = ({ t, productId }) => {
  const [cashback, setCashback] = useState('')
  const handleOnClickGoToOrders = () => {
    segmentPdpGoToOrdersClicked({
      id_product: productId,
    })
  }
  const token = StateStorage.getAuthToken()

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const cashbackConfig = await ReviewApiHandler.getReviewCashback()
        setCashback(cashbackConfig?.review_cashback_config?.total)
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
    if (token) {
      fetchReview()
    }
  }, [token])

  return (
    <div
      data-cy="product-reviews-empty-container"
      className="product-reviews-empty-container"
    >
      <style jsx>{styles}</style>
      <div>
        <div style={{ marginBottom: '30px' }} className={clsx(Typo.body1)}>
          {hasLocizeTranslation(
            t,
            'NO_REVIEWS_POSTED_YET',
            'No reviews posted yet.',
          )}
        </div>
        <div className={Typo.body2}>
          {hasLocizeTranslation(t, 'BOUGHT_THIS_ITEM', 'Bought this item?')}
        </div>
        <div className={Typo.body2}>
          {hasLocizeTranslation(
            t,
            'PRODUCT_REVIEWS_GO_TO_ORDERS_CASHBACK',
            'Go to your orders history to write a review and earn up to %s cashback.',
          ).replace('%s', cashback)}
        </div>
        <Button
          style={{ color: '#000' }}
          target="_blank"
          type={BUTTON_TYPES.link}
          link
          aProps={{ href: '/user/orders' }}
          onClick={handleOnClickGoToOrders}
        >
          {hasLocizeTranslation(t, 'CLICK_HERE', 'Click Here!')}
        </Button>
      </div>
    </div>
  )
}

ProductReviewsEmpty.propTypes = {
  // redux props
  t: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ProductReviewsEmpty)
